export default __webpack_public_path__ + "static/media/numpy.044b7cdc.png";